import React from "react";
import { Row } from "react-bootstrap";
import CardBody from "./AdminCardBody";
import CardHeader from "./CardHeader";

const AdminCard = ({
  type,
  title,
  data,
  modal,
  modalLink,
  moduleid,
  fetchLearningModuleData
}: {
  type: number;
  title: String;
  data: any;
  modal?: any;
  modalLink?: any;
  moduleid:number,
  fetchLearningModuleData:any
}) => {
  return (
    <>
      <Row
        className={
          type === 1 ? "bgwhite b_shadow p_all" : "shadowLRB rowBg p_all"
        }
        style={{ paddingTop: type != 1 ? "0px" : "" }}
      >
        <CardHeader title={title} modal={modal} />
        <CardBody data={data} type={type} linkTitle={modalLink} moduleid={moduleid} fetchLearningModuleData={fetchLearningModuleData} />
      </Row>
    </>
  );
};

export default AdminCard;
